import { Injectable } from '@angular/core';
import { IBattery, IQuestionnaire } from '@models';

const apiUrl = 'http://localhost:4200';
const branding = {
    orgName: 'Adirondack Health',
    logoUrl: 'https://qa.patientoutcomes.com/static/images/org/91/email.png',
    faviconUrl:
        'https://qa.patientoutcomes.com/static/images/org/91/favicon.ico',
    theme: {
        primaryColor: '0060AA',
        secondaryColor: '014D33',
    },
};

const branding_orange = {
    orgName: 'Stryker- Dr. Paul Jacob',
    logoUrl: 'https://qa.patientoutcomes.com/static/images/org/101/email.png',

    faviconUrl:
        'https://qa.patientoutcomes.com/static/images/org/101/favicon.ico',
    theme: {
        primaryColor: '#B05E2F',
        secondaryColor: '#3A3A38',
    },
};

const AAOSFootBattery: IBattery = {
    id: '10',
    title: 'AAOS Foot & Ankle',
    copyright: null,
};

const AAOSLowerBattery: IBattery = {
    id: '11',
    title: 'AAOS Lower Limb',
    copyright:
        '&copy; EuroQol Research Foundation.  EQ-5D&trade; is a trade mark of the EuroQol Research Foundation.  USA (English) Version number v1.1',
};

const FAAMBattery: IBattery = {
    id: '12',
    title: 'FAAM',
    copyright:
        '&copy; EuroQol Research Foundation.  EQ-5D&trade; is a trade mark of the EuroQol Research Foundation.  USA (English) Version number v1.1',
};

const OlerudBattery: IBattery = {
    id: '13',
    title: 'Olerud & Molander Ankle Scale',
    copyright: null,
};

const ASESBattery: IBattery = {
    id: '14',
    title: 'ASES',
    copyright: null,
};

const DASHBattery: IBattery = {
    id: '15',
    title: 'DASH',
    copyright: null,
};

const SILSBattery: IBattery = {
    id: '16',
    title: 'SILS',
    copyright: null,
};

const koosBattery: IBattery = {
    id: '4',
    title: 'KOOS Knee Scale',
    copyright: null,
};

const promisBattery: IBattery = {
    id: '8',
    title: 'PROMIS Global 10',
    copyright: null,
};

// 75c9971ef240369c
const questionnaire: IQuestionnaire = {
    id: '2858782',
    status: 'In Progress',
    statusMessage: '',
    displayScores: true,
    batteries: [
        AAOSFootBattery,
        AAOSLowerBattery,
        FAAMBattery,
        OlerudBattery,
        ASESBattery,
        DASHBattery,
        SILSBattery,
    ],
};

const questionnaireAfterSubmition = {
    id: 2858782,
    status: 'In Progress',
    statusMessage: '',
    batteries: [
        { id: 4, title: 'KOOS Knee Scale', copyright: null as null },
        { id: 8, title: 'PROMIS Global 10', copyright: null as null },
    ],
};

const screen4 = {
    id: 4,
    dataId: 4,
    type: 'Splash',
    previousScreenId: 52,
    status: 5,
    lastScreen: false,
};
const question4 = {
    id: '4',
    questionnaireId: '75c9971ef240369c',
    batteryId: '4',
    text: '<b>Symptoms<\u002fb>: The following questions should be answered thinking of your knee symptoms during the <b>last week<\u002fb>. <br><br> If you do not currently perform some of the activities described in these questions, please try to imagine how your knee might feel when performing these activities, and answer accordingly.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [] as string[],
        },
    },
};
const answer = [];
const screen5 = {
    id: 5,
    dataId: 5,
    type: 'Question',
    previousScreenId: 4,
    status: 6,
    lastScreen: false,
};
const question5 = {
    id: 5,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<div class="question-big-centered-text">Patient Satisfaction</div><div class="question-small-text"><b>Symptoms</b>: The following questions should be answered thinking of your knee symptoms during the <b>last week</b>.</div>Do you have swelling in your knee?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 14,
                    displayText: 'Never',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 15,
                    displayText: 'Rarely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 16,
                    displayText: 'Sometimes',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 17,
                    displayText: 'Often',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 18,
                    displayText: 'Always',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen66 = {
    id: 66,
    dataId: 66,
    type: 'Question',
    previousScreenId: 5,
    status: 8,
    lastScreen: false,
};

const question66 = {
    id: 66,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: 4,
    text: 'How would you rate your <b>chest wall</b> as a percentage of normal (0% to 100% scale with <b>100%</b> being <b>normal</b>)?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'value',
            value: {
                validation: {
                    minValue: 0,
                    maxValue: 100,
                },
            },
        },
    },
};

const screen69 = {
    id: 69,
    dataId: 69,
    type: 'Question',
    previousScreenId: 66,
    status: 8,
    lastScreen: false,
};

const question69 = {
    id: 69,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: 11,
    text: '<ul><li>We would like to know how good or bad your health is TODAY.</li><li>This scale is numbered from 0 to 100.</li><li>100 means the <u>best</u> health you can imagine.<br>0 means the <u>worst</u> health you can imagine.</li><li>Please click or tap on the scale to indicate how your health is TODAY.</li></ul>',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'range',
            range: {
                minValue: 0,
                maxValue: 100,
                valueStep: 1,
                vertical: true,
                minValueLabel: 'The worst health you can imagine',
                maxValueLabel: 'The best health you can imagine',
                showCurrentValue: true,
                showCurrentValueText: 'YOUR HEALTH TODAY = ',
                showValuesStep: 10,
                smallTicksStep: 1,
                mediumTicksStep: 5,
                largeTicksStep: 10,
                tickLocation: 'center',
                showTip: true,
                eq5dCompliant: true,
            },
        },
    },
};

const screen70 = {
    id: 70,
    dataId: 70,
    type: 'Question',
    previousScreenId: 69,
    status: 8,
    lastScreen: false,
};

const question70 = {
    id: 70,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: 12,
    text: '<ul><li>Second We would like to know how good or bad your health is TODAY.</li><li>This scale is numbered from 0 to 100.</li><li>100 means the <u>best</u> health you can imagine.<br>0 means the <u>worst</u> health you can imagine.</li><li>Please click or tap on the scale to indicate how your health is TODAY.</li></ul>',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'range',
            range: {
                minValue: 0,
                maxValue: 10,
                valueStep: 1,
                vertical: true,
                minValueLabel: 'The worst health you can imagine',
                maxValueLabel: 'The best health you can imagine',
                showCurrentValue: true,
                showCurrentValueText: 'YOUR HEALTH TODAY = ',
                showValuesStep: 1,
                // smallTicksStep: 10,
                // mediumTicksStep: 5,
                // largeTicksStep: 2,
                tickLocation: 'center',
                showTicks: true,
                showTip: true,
            },
        },
    },
};

const screen71 = {
    id: 71,
    dataId: 71,
    type: 'Question',
    previousScreenId: 70,
    status: 8,
    lastScreen: false,
};

const question71 = {
    id: 71,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: 12,
    text: '<ul><li>333 Second We would like to know how good or bad your health is TODAY.</li><li>This scale is numbered from 0 to 100.</li><li>100 means the <u>best</u> health you can imagine.<br>0 means the <u>worst</u> health you can imagine.</li><li>Please click or tap on the scale to indicate how your health is TODAY.</li></ul>',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'range',
            range: {
                minValue: 0,
                maxValue: 100,
                valueStep: 10,
                vertical: true,
                minValueLabel: 'The worst health you can imagine',
                maxValueLabel: 'The best health you can imagine',
            },
        },
    },
};

const screen72 = {
    id: 72,
    dataId: 72,
    type: 'Question',
    previousScreenId: 71,
    status: 8,
    lastScreen: false,
};

const question72 = {
    id: 72,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: 12,
    text: '<ul><li>w2222 Second We would like to know how good or bad your health is TODAY.</li><li>This scale is numbered from 0 to 100.</li><li>100 means the <u>best</u> health you can imagine.<br>0 means the <u>worst</u> health you can imagine.</li><li>Please click or tap on the scale to indicate how your health is TODAY.</li></ul>',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'range',
            range: {
                largeTicksStep: 2,
                maxValue: 10,
                maxValueLabel: 'No Pain',
                minValue: 0,
                minValueLabel: 'Worst Possible Pain',
                showValuesStep: 2,
                tickLocation: 'below',
                valueStep: 1,
                vertical: false,
            },
        },
    },
};

const screen73 = {
    id: 73,
    dataId: 73,
    type: 'Question',
    previousScreenId: 72,
    status: 8,
    lastScreen: false,
};

const question73 = {
    id: 73,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: 12,
    text: '<ul><li>73 Second We would like to know how good or bad your health is TODAY.</li><li>This scale is numbered from 0 to 100.</li><li>100 means the <u>best</u> health you can imagine.<br>0 means the <u>worst</u> health you can imagine.</li><li>Please click or tap on the scale to indicate how your health is TODAY.</li></ul>',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'range',
            range: {
                largeTicksStep: 2,
                maxValue: 10,
                maxValueLabel: 'No Pain',
                minValue: 0,
                minValueLabel: 'Worst Possible Pain',
                showValuesStep: 2,
                tickLocation: 'below',
                valueStep: 1,
                vertical: true,
            },
        },
    },
};

const screen6 = {
    id: 6,
    dataId: 5,
    type: 'Question',
    previousScreenId: 5,
    status: 8,
    lastScreen: false,
};

const question6 = {
    id: 6,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Symptoms<\u002fb>: The following questions should be answered thinking of your knee symptoms during the <b>last week<\u002fb>.<\u002fsmall> <br><br> Do you feel grinding, hear clicking or any other type of noise when your knee moves?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 19,
                    displayText: 'Never',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 20,
                    displayText: 'Rarely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 21,
                    displayText: 'Sometimes',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 22,
                    displayText: 'Often',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 23,
                    displayText: 'Always',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen7 = {
    id: 7,
    dataId: 7,
    type: 'Question',
    previousScreenId: 6,
    status: 9,
    lastScreen: false,
};

const question7 = {
    id: 7,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Symptoms<\u002fb>: The following questions should be answered thinking of your knee symptoms during the <b>last week<\u002fb>.<\u002fsmall> <br><br> Does your knee catch or hang up when moving?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 24,
                    displayText: 'Never',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 25,
                    displayText: 'Rarely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 26,
                    displayText: 'Sometimes',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 27,
                    displayText: 'Often',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 28,
                    displayText: 'Always',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen8 = {
    id: 8,
    dataId: 8,
    type: 'Question',
    previousScreenId: 7,
    status: 11,
    lastScreen: false,
};

const question8 = {
    id: 8,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Symptoms<\u002fb>: The following questions should be answered thinking of your knee symptoms during the <b>last week<\u002fb>.<\u002fsmall> <br><br> Can you straighten your knee fully?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 29,
                    displayText: 'Always',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 30,
                    displayText: 'Often',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 31,
                    displayText: 'Sometimes',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 32,
                    displayText: 'Rarely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 33,
                    displayText: 'Never',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen9 = {
    id: 9,
    dataId: 9,
    type: 'Question',
    previousScreenId: 8,
    status: 12,
    lastScreen: false,
};

const question9 = {
    id: 9,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Symptoms<\u002fb>: The following questions should be answered thinking of your knee symptoms during the <b>last week<\u002fb>.<\u002fsmall> <br><br> Can you bend your knee fully?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 34,
                    displayText: 'Always',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 35,
                    displayText: 'Often',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 36,
                    displayText: 'Sometimes',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 37,
                    displayText: 'Rarely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 38,
                    displayText: 'Never',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen10 = {
    id: 10,
    dataId: 10,
    type: 'Question',
    previousScreenId: 9,
    status: 14,
    lastScreen: false,
};

const question10 = {
    id: 10,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<b>Stiffness<\u002fb>: The following questions concern the amount of joint stiffness you have experienced during the <b>last week<\u002fb> in your knee. Stiffness is a sensation of restriction or slowness in the ease with which you move your knee joint. <br><br> If you do not currently perform some of the activities described in these questions, please try to imagine how your knee might feel when performing these activities, and answer accordingly.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [] as string[],
        },
    },
};

const screen11 = {
    id: 11,
    dataId: 11,
    type: 'Question',
    previousScreenId: 10,
    status: 15,
    lastScreen: false,
};

const question11 = {
    id: 11,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Stiffness<\u002fb>: The following questions concern the amount of joint stiffness you have experienced during the <b>last week<\u002fb> in your knee.<\u002fsmall> <br><br> How severe is your knee joint stiffness after first wakening in the morning?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 39,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 40,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 41,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 42,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 43,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen12 = {
    id: 12,
    dataId: 12,
    type: 'Question',
    previousScreenId: 11,
    status: 17,
    lastScreen: false,
};

const question12 = {
    id: 12,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Stiffness<\u002fb>: The following questions concern the amount of joint stiffness you have experienced during the <b>last week<\u002fb> in your knee.<\u002fsmall> <br><br> How severe is your knee stiffness after sitting, lying or resting <b>later in the day<\u002fb>?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 44,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 45,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 46,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 47,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 48,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen13 = {
    id: 13,
    dataId: 13,
    type: 'Question',
    previousScreenId: 12,
    status: 18,
    lastScreen: false,
};

const question13 = {
    id: 13,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<b>Pain<\u002fb>: The following questions concern how often you experience knee pain, and during what activities. <br><br> If you do not currently perform some of the activities described in these questions, please try to imagine how your knee might feel when performing these activities, and answer accordingly.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: { type: 'list', list: [] as string[] },
    },
};

const screen14 = {
    id: 14,
    dataId: 14,
    type: 'Question',
    previousScreenId: 13,
    status: 20,
    lastScreen: false,
};
const question14 = {
    id: 14,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> How often do you experience knee pain?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 49,
                    displayText: 'Never',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 50,
                    displayText: 'Monthly',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 51,
                    displayText: 'Weekly',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 52,
                    displayText: 'Daily',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 53,
                    displayText: 'Always',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen15 = {
    id: 15,
    dataId: 15,
    type: 'Question',
    previousScreenId: 14,
    status: 22,
    lastScreen: false,
};
const question15 = {
    id: 15,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when twisting/pivoting on your knee?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 54,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 55,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 56,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 57,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 58,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen16 = {
    id: 16,
    dataId: 16,
    type: 'Question',
    previousScreenId: 15,
    status: 23,
    lastScreen: false,
};
const question16 = {
    id: 16,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when straightening your knee fully?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 59,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 60,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 61,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 62,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 63,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen17 = {
    id: 17,
    dataId: 17,
    type: 'Question',
    previousScreenId: 16,
    status: 25,
    lastScreen: false,
};
const question17 = {
    id: 17,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when bending your knee fully?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 64,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 65,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 66,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 67,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 68,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen18 = {
    id: 18,
    dataId: 18,
    type: 'Question',
    previousScreenId: 17,
    status: 26,
    lastScreen: false,
};
const question18 = {
    id: 18,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when walking on a flat surface?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 69,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 70,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 71,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 72,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 73,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen19 = {
    id: 19,
    dataId: 19,
    type: 'Question',
    previousScreenId: 18,
    status: 28,
    lastScreen: false,
};
const question19 = {
    id: 19,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when going up or down stairs?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 74,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 75,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 76,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 77,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 78,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen20 = {
    id: 20,
    dataId: 20,
    type: 'Question',
    previousScreenId: 19,
    status: 29,
    lastScreen: false,
};
const question20 = {
    id: 20,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> at night while in bed?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 79,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 80,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 81,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 82,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 83,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen21 = {
    id: 21,
    dataId: 21,
    type: 'Question',
    previousScreenId: 20,
    status: 31,
    lastScreen: false,
};
const question21 = {
    id: 21,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when sitting or lying?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 84,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 85,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 86,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 87,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 88,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen22 = {
    id: 22,
    dataId: 22,
    type: 'Question',
    previousScreenId: 21,
    status: 32,
    lastScreen: false,
};
const question22 = {
    id: 22,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Pain<\u002fb><\u002fsmall> <br> What amount of knee pain have you experienced the <b>last week<\u002fb> when standing upright?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 89,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 90,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 91,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 92,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 93,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen23 = {
    id: 23,
    dataId: 23,
    type: 'Question',
    previousScreenId: 22,
    status: 34,
    lastScreen: false,
};
const question23 = {
    id: 23,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<b>Function, daily living<\u002fb>: The following questions concern your physical function. By this we mean your ability to move around and to look after yourself.  For each of the following activities please indicate the degree of difficulty you have experienced in the <b>last week<\u002fb> due to your knee. <br><br> If you do not currently perform some of the activities described in these questions, please try to imagine how your knee might feel when performing these activities, and answer accordingly.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: { type: 'list', list: [] as string[] },
    },
};
const screen24 = {
    id: 24,
    dataId: 24,
    type: 'Question',
    previousScreenId: 23,
    status: 35,
    lastScreen: false,
};
const question24 = {
    id: 24,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Function, daily living<\u002fb>: Please indicate the degree of difficulty you have experienced in the <b>last week<\u002fb> due to your knee.<\u002fsmall> <br><br> Descending stairs?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 94,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 95,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 96,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 97,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 98,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen25 = {
    id: 25,
    dataId: 25,
    type: 'Question',
    previousScreenId: 24,
    status: 37,
    lastScreen: false,
};
const question25 = {
    id: 25,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Function, daily living<\u002fb>: Please indicate the degree of difficulty you have experienced in the <b>last week<\u002fb> due to your knee.<\u002fsmall> <br><br> Ascending stairs?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 99,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 100,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 101,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 102,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 103,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen26 = {
    id: 26,
    dataId: 26,
    type: 'Question',
    previousScreenId: 25,
    status: 38,
    lastScreen: false,
};
const question26 = {
    id: 26,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Function, daily living<\u002fb>: Please indicate the degree of difficulty you have experienced in the <b>last week<\u002fb> due to your knee.<\u002fsmall> <br><br> Rising from sitting?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 104,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 105,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 106,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 107,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 108,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen27 = {
    id: 27,
    dataId: 27,
    type: 'Question',
    previousScreenId: 26,
    status: 40,
    lastScreen: false,
};
const question27 = {
    id: 27,
    questionnaireId: '75c9971ef240369c',
    batteryId: 4,
    text: '<small><b>Function, daily living<\u002fb>: Please indicate the degree of difficulty you have experienced in the <b>last week<\u002fb> due to your knee.<\u002fsmall> <br><br> Standing?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 109,
                    displayText: 'None',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 110,
                    displayText: 'Mild',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 111,
                    displayText: 'Moderate',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 112,
                    displayText: 'Severe',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 113,
                    displayText: 'Extreme',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screen2 = {
    id: 2,
    dataId: 2,
    type: 'Question',
    previousScreenId: 8,
    status: 95,
    lastScreen: false,
};
const question2 = {
    id: 2,
    questionnaireId: '75c9971ef240369c',
    batteryId: null as null,
    text: "<b>Patient Satisfaction<\u002fb>: This part of the assessment asks about your level of satisfaction as a patient with your physician and your physician's staff.",
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: false,
            commentMandatory: false,
        },
        values: { type: 'list', list: [] as string[] },
    },
};
const screen67 = {
    id: 67,
    dataId: 67,
    type: 'Question',
    previousScreenId: 2,
    status: 97,
    lastScreen: false,
};
const question67 = {
    id: 67,
    questionnaireId: '75c9971ef240369c',
    batteryId: null as null,
    text: '<small><b>Patient Satisfaction<\u002fb><\u002fsmall> <br> The results of the surgery have met my expectations.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: true,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 298,
                    displayText: '10 - Strongly agree',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 299,
                    displayText: '9',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 300,
                    displayText: '8',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 301,
                    displayText: '7',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 302,
                    displayText: '6',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 303,
                    displayText: '5',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 304,
                    displayText: '4',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 305,
                    displayText: '3',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 306,
                    displayText: '2',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 307,
                    displayText: '1',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 308,
                    displayText: '0 - Strongly disagree',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};
const screen3 = {
    id: 3,
    dataId: 3,
    type: 'Question',
    previousScreenId: 67,
    status: 98,
    lastScreen: false,
};
const question3 = {
    id: 3,
    questionnaireId: '75c9971ef240369c',
    batteryId: null as null,
    text: '<small><b>Patient Satisfaction<\u002fb><\u002fsmall> <br> How likely are you to recommend your surgeon to friends and family?',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: true,
            commentAvailable: true,
            commentMandatory: false,
        },
        values: {
            type: 'list',
            list: [
                {
                    id: 3,
                    displayText: '10 - Very likely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 4,
                    displayText: '9',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 5,
                    displayText: '8',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 6,
                    displayText: '7',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 7,
                    displayText: '6',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 8,
                    displayText: '5',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 9,
                    displayText: '4',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 10,
                    displayText: '3',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 11,
                    displayText: '2',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 12,
                    displayText: '1',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
                {
                    id: 13,
                    displayText: '0 - Very unlikely',
                    validation: {
                        commentAvailable: false,
                        commentMandatory: false,
                    },
                },
            ],
        },
    },
};

const screenSubmit68 = {
    id: 68,
    dataId: 68,
    type: 'Submit',
    previousScreenId: 3,
    status: 100,
    lastScreen: true,
};
const question68 = {
    id: 68,
    questionnaireId: '9a18bbd16bcfa4f9',
    batteryId: null as null,
    text: 'Please share any comments that will help us better care for patients like you.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: true,
            commentMandatory: false,
        },
        values: { type: 'list', list: [] as string[] },
    },
};

const screenSubmit = {
    id: 53,
    dataId: 53,
    type: 'Submit',
    previousScreenId: 3,
    status: 100,
    lastScreen: true,
};
const question53 = {
    id: 53,
    questionnaireId: '75c9971ef240369c',
    batteryId: null as null,
    text: 'Please share any comments that will help us better care for patients like you.',
    answerSettings: {
        validation: {
            multipleAnswersAvailable: false,
            mandatoryAnswer: false,
            commentAvailable: true,
            commentMandatory: false,
        },
        values: { type: 'list', list: [] as string[] },
    },
};

const gratitudeScreen = { type: 'Gratitude', status: 100 };
const gratitude = {
    questionnaireId: '75c9971ef240369c',
    text: 'Thank you for completing this assessment! <br><div class="small">For further questions regarding scheduling, obtaining records, or medical questions and assistance, please contact your provider’s office directly.</div>',
};

const scores = {
    surveyInterval: {
        label: 'There are your most recent scores resulted from your survey for the <b>3 month Post-op interval.</b>',
    },
    scoreComponents: [
        {
            toolName: 'HOOS JR',
            toolDescription:
                '<b>Hip Disability and Osteoarthritis Outcome Score, Joint Replacement</b> is a short form that assesses patient pain, and functions of daily living. Scores range from 0 to 100 with a score of 0 indicating total hip disability and 100 indicating perfect hip health.',
            toolMetaDescription:
                'A score of <b>0</b> is indicating <b>total hip disability</b> and <b>100</b> is indicating <b>perfect hip health</b>.',
            patientScore: 73,
            maxRangeValue: 100,
            previousScore: {
                value: 53,
                differenceValue: 20,
                differenceLabel: 'vs Pre-op scores',
                displayPercentile: false,
                displayPoints: true,
            },
            benchmarkScore: {
                value: 78,
                differenceValue: -5,
                differenceLabel: 'vs all patients',
                displayPercentile: false,
                displayPoints: true,
            },
        },
        {
            toolName: 'PROMIS Global Physical Health',
            toolDescription:
                '<b>Physical Disability and Osteoarthritis Outcome Score, Joint Replacement</b> is a short form that assesses patient pain, and functions of daily living. Scores range from 0 to 100 with a score of 0 indicating total hip disability and 100 indicating perfect hip health.',
            toolMetaDescription:
                'A score of <b>0</b> is indicating <b>total physical disability</b> and <b>100</b> is indicating <b>perfect physical health</b>.',
            patientScore: 51,
            maxRangeValue: 100,
            previousScore: {
                value: 53,
                differenceValue: -21,
                differenceLabel: 'vs Pre-op scores',
                displayPercentile: true,
                displayPoints: true,
            },
            benchmarkScore: {
                value: 78,
                differenceValue: 5,
                differenceLabel: 'vs all patients',
                displayPercentile: false,
                displayPoints: true,
            },
        },
        {
            toolName: 'PROMIS Global Mental Health',
            toolDescription:
                '<b>Hip Disability and Osteoarthritis Outcome Score, Joint Replacement</b> is a short form that assesses patient pain, and functions of daily living. Scores range from 0 to 100 with a score of 0 indicating total hip disability and 100 indicating perfect hip health.',
            toolMetaDescription:
                'A score of <b>0</b> is indicating <b>total mental disability</b> and <b>100</b> is indicating <b>perfect mental health</b>.',
            patientScore: 2,
            maxRangeValue: 100,
            previousScore: null,
            benchmarkScore: {
                value: 78,
                differenceValue: -5,
                differenceLabel: 'vs all patients',
                displayPercentile: false,
                displayPoints: true,
            },
        },
    ],
};

const gratitudeScreen2 = { type: 'Gratitude', status: 100 };
const gratitude2 = {
    questionnaireId: '9a18bbd16bcfa4f9',
    text: 'Thank you for completing this assessment! <br><div class="small">For further questions regarding scheduling, obtaining records, or medical questions and assistance, please contact your provider’s office directly.</div>',
    resources: {
        video: {
            link: 'https://www.youtube.com/watch?v=3zDLY6Ulh5U',
            text: 'Any text that concerns the video content e.g. question text, explaining text, etc. Any text that concerns the video content e.g. question text, explaining text, etc.',
        },
    },
};

const researchSubjInfoScreen = {
    id: 75,
    dataId: 75,
    type: 'ResearchSubjectInfo',
    previousScreenId: 3,
    status: 10,
    lastScreen: false,
};

const research_subject_info = {
    questionnaireId: '0987654321',
    text: 'Research Subject Information and Consent Form',
    titleLable: 'TITLE:',
    title: 'Establishing a Clinical Outcomes Registry/Database from Joint Replacement Surgery',
    protocolNoLabel: 'PROTOCOL NO.:',
    protocolNo: 'None<br/>WIRB® Protocol #20141065',
    sponsorLabel: 'SPONSOR:',
    sponsor: 'DePuy Synthes, a Johnson & Johnson company',
    investigatorLabel: 'INVESTIGATOR:',
    investigator:
        'Robert S. Gorab II, MD<br/>280 S. Main Street, Suite 200<br/>Orange, California 92868<br/>United States',
    sitesLabel: 'SITE(S):',
    sites: 'Orthopaedic Specialty Institute<br/>16300 Sand Canyon Avenue, Suite 511<br/>Irvine, CA 92618<br/>United States',
};

const subjectConsentScreen = {
    id: 76,
    dataId: 76,
    type: 'SubjectConsent',
    previousScreenId: 75,
    status: 10,
    lastScreen: false,
};
const subject_consent = {
    questionnaireId: '0987654321',
    text: 'Subject Consent<div class="small left">I have read this consent form (or it has been read to me). All my questions about the study and my part in it have been answered. I freely consent to be in this research study.</div><div class="small left">By signing this consent form, I have not given up any of my legal rights.</div>',
    consentLabel: 'I consent',
    dontConsentLabel: `I do not consent`,
    firstAndLastNamePlaceholder: 'Please enter your FIRST and LAST NAME',
    aceptSignatureLabel: 'Accept as a signature',
};

const researchQuestionScreen = {
    id: 77,
    dataId: 77,
    type: 'ResearchQuestion',
    previousScreenId: 76,
    status: 10,
    lastScreen: false,
};
const research_question = {
    questionnaireId: '0987654321',
    text: 'Research Questions<div class="small left">WIRB will not be bale to answer some study-specific questions, such as questions about appointment times. However, you may submit questions and the research staff will contact you to answer your questions.</div><div class="small left">Do not sign this consent form unless you have had a chance to ask questions and have gotten satisfactory answers.</div><div class="small left">If you agree to be in this study, you will receive a signed and dated copy of this consent form for your records.</div>',
    questionPlaceholder: 'Please enter ANY QUESTIONS you have about the study',
    noQuestionLabel: 'I do not have any questions',
};

const data = new Map<string, Map<string, any>>([
    [
        'GET',
        new Map<string, any>([
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9',
                { status: 200, body: questionnaire },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/branding',
                { status: 200, body: branding_orange },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/screen',
                (function* () {
                    // yield { status: 200, body: screen4 };
                    // yield { status: 200, body: screen5 };
                    // yield { status: 200, body: screen66 };
                    // yield { status: 200, body: screen7 };

                    // yield { status: 200, body: screen69 };
                    // yield { status: 200, body: screen70 };
                    // yield { status: 200, body: screen71 };
                    // yield { status: 200, body: screen72 };
                    // yield { status: 200, body: screen73 };
                    // yield { status: 200, body: researchSubjInfoScreen };
                    // yield { status: 200, body: subjectConsentScreen };
                    yield { status: 200, body: researchQuestionScreen };
                    // yield { status: 200, body: screenSubmit68 };
                    yield { status: 200, body: gratitudeScreen2 };
                })(),
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/4',
                { status: 200, body: question4 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/5',
                { status: 200, body: question5 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/66',
                { status: 200, body: question66 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/66/answer',
                {
                    status: 200,
                    body: {
                        questionId: 66,
                        values: [{ value: 20 }],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/7',
                { status: 200, body: question7 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/68',
                { status: 200, body: question68 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/69',
                { status: 200, body: question69 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/70',
                { status: 200, body: question70 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/71',
                { status: 200, body: question71 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/72',
                { status: 200, body: question72 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/question/73',
                { status: 200, body: question73 },
            ],
            [
                apiUrl +
                    '/questionnaire/9a18bbd16bcfa4f9/research-subject-info',
                { status: 200, body: research_subject_info },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/subject-consent',
                { status: 200, body: subject_consent },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/research-question',
                { status: 200, body: research_question },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/gratitude',
                { status: 200, body: gratitude2 },
            ],
            [
                apiUrl + '/questionnaire/9a18bbd16bcfa4f9/score',
                { status: 200, body: scores },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c',
                { status: 200, body: questionnaire },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/branding',
                { status: 200, body: branding },
            ],
            [
                apiUrl + '/questionnaire/f55eca7cdc675201/faq',
                {
                    success: true,
                    body: '<section>\n    <h1>Tracking Your Recovery After Surgery<\u002fh1>\n\n    <p>\n        Shortly after you are scheduled for surgery with a provider from Adirondack Health, we will ask you to fill out a quick assessment about\n        how you are functioning before surgery, and then again at various intervals\n        after surgery. These "assessments" are far more than just a survey — they are\n        rigorously-tested, scientifically-validated measurement tools. These tools are\n        called patient-reported outcomes (PROs), and they are one of the key methods\n        Adirondack Health uses to track how our patients are doing, as\n        well as how to get the best possible outcomes for you.\n    <\u002fp>\n\n    <p>\n        PROs essentially reflect the "voice of the patient" — free from the input and\n        interpretation of physicians and medical experts. We want to make sure <i>your<\u002fi>\n        voice is heard and <i>your<\u002fi> outcome is tracked. To ensure the quality of our outcome\n        information, we partner with an independent 3rd-party company to collect PROs\n        before surgery, and at various intervals for 5 years after surgery. This program\n        allows our team to respond to you, the patient, and to create a patient-centered\n        environment that supports continuous quality improvement. We greatly appreciate\n        your participation in this process.\n    <\u002fp>\n<\u002fsection>\n\n<section>\n\n    <h2>Frequently Asked Questions<\u002fh2>\n\n    <ul>\n        <li><a href="#what-are-pros">What are PRO assessments?<\u002fa><\u002fli>\n        <li><a href="#pros-are-different">How are PROs different than other measurements of my health after surgery?<\u002fa><\u002fli>\n        <li><a href="#how-long-will-it-take">How long will this take?<\u002fa><\u002fli>\n        <li><a href="#navigating-away">What happens if I navigate away from the page during my assessment?<\u002fa><\u002fli>\n        <li><a href="#complications">I\'m having problems, such as an unexpected complication after surgery. Should I still take this?<\u002fa><\u002fli>\n        <li><a href="#online-v-phone">What is the benefit of doing this online vs over the phone?<\u002fa><\u002fli>\n        <li><a href="#cant-skip-question">Why can\'t I skip questions that clearly don\'t apply to me?<\u002fa><\u002fli>\n        <li><a href="#questions-repetitive">Why do some of the questions seem repetitive?<\u002fa><\u002fli>\n        <li><a href="#took-for-another-body-part">I already filled out an assessment for my other knee/shoulder/etc. Do I need to go through these questions again?<\u002fa><\u002fli>\n        <li><a href="#does-this-matter">Why does this matter?<\u002fa><\u002fli>\n        <li><a href="#question-for-my-surgeon">I have questions for my surgeon and staff. Can I leave them as a comment in the assessment, or reply to the email/text message that contains the assessment link?<\u002fa><\u002fli>\n        <li><a href="#who-reads-my-comments">Do people read my comments?<\u002fa><\u002fli>\n        <li><a href="#why-3rd-party">Why do you use a 3rd-party company?<\u002fa><\u002fli>\n        <li><a href="#contact">Have a question we didn\'t answer? Contact our outcome team!<\u002fa><\u002fli>\n    <\u002ful>\n\n<\u002fsection>\n\n<section class="answers">\n\n    <div id="question1">\n        <h3 id="what-are-pros">What are PRO assessments?<\u002fh3>\n        <p>A patient-reported outcome (PRO) assessment is not just a typical "survey" &mdash; it is a set of statistically validated questions that have been rigorously tested through medical research. PROs are designed to measure both your physical recovery, as well as the improvement to your overall quality of life. These tools are used by orthopedic surgeons around the world, and are becoming the "gold standard" for evaluating surgical results.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question2">\n        <h3 id="pros-are-different">How are PROs different than other measurements of my health after surgery?<\u002fh3>\n        <p>Traditionally, surgical care teams focus on measuring the size of the incision or how much range of motion a patient has or how the x-ray looks to the surgeon. These factors may all have some role in surgical outcomes, but they aren\'t <i>patient driven<\u002fi>. PROs make you, the patient, an active participant in your recovery, allowing your care team to check on how <i>you<\u002fi> feel and how <i>your<\u002fi> goals are being met.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question3">\n        <h3 id="how-long-will-it-take">How long will this take?<\u002fh3>\n        <p>It usually takes about 10-20 minutes to complete a PRO assessment.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question4">\n        <h3 id="navigating-away">What happens if I navigate away from the page during my assessment?<\u002fh3>\n        <p>If you navigate away from the page while you\'re taking your assessment, you\'ll have to start again at the beginning when you return to it. So please plan on finishing in one sitting.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question5">\n        <h3 id="complications">I\'m having problems, such as an unexpected complication after surgery. Should I still take this?<\u002fh3>\n        <p>Yes, please do! While it is very rare, a small portion of the patients who have orthopedic surgery suffer from complications. We want to understand more about these complications, and why they occur, so we can learn to prevent them and better care for you, and other patients like you, in the future.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question6">\n        <h3 id="online-v-phone">What is the benefit of doing this online vs over the phone?<\u002fh3>\n        <p>First and foremost: data quality. Eliminating any outside influence while completing the assessment improves the accuracy of your answers. Another benefit is time &mdash; almost all PRO questions are multiple choice, and when doing the assessment over the phone, all answer options must be read by the assessment administrator, even when the answer options are the same for many questions. On average, it takes patients 40% less time to complete an assessment online than over the phone.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question7">\n        <h3 id="cant-skip-question">Why can\'t I skip questions that clearly don\'t apply to me?<\u002fh3>\n        <p>In order for the system to calculate a standardized score that can be compared to other patients who\'ve undergone similar treatment, each question must be answered. Some questions or answer options may not seem relevant to your situation &mdash; but the good news is, there are no "trick" questions. So please try to answer all questions to the best of your ability; and if a question asks about something you can\'t or don\'t do (like if the question asks about your ability to jump, even though it\'s not something you do very often), try to imagine yourself performing that activity, and answer the question imagining how your body would feel or react. At the end of the assessment, you will be able to include your own comments with any additional information not previously covered that you feel may be beneficial for your surgeon to know.<\u002fp>\n    <\u002fdiv>\n\n    <div>\n        <h3 id="questions-repetitive">Why do some of the questions seem repetitive?<\u002fh3>\n        <p>The questions in each PRO assessment are designed to evaluate specific areas of your current physical state. Although some questions may seem repetitive, they are evaluating different aspects of the factors that affect your recovery, such as pain, level of difficulty performing a task, etc. Please answer all questions to the best of your ability.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question8">\n        <h3 id="took-for-another-body-part">I already filled out an assessment for my other knee/shoulder/etc. Do I need to go through these questions again?<\u002fh3>\n        <p>Yes. Since procedures and practices continually change, it\'s important to monitor the progress of each individual procedure, even for the same patient.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question9">\n        <h3 id="does-this-matter">Why does this matter?<\u002fh3>\n        <p>The recovery process is different for all patients. However, there are certain standards that physicians strive for in the recovery process. PRO assessments allow physicians to compare your results to other similar individuals, and monitor trends. This allows your surgeon to better understand what to expect for your specific recovery, and can alter your plan of care if necessary.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question10">\n        <h3 id="question-for-my-surgeon">I have questions for my surgeon and staff. Can I leave them as a comment in the assessment, or reply to the email/text message that contains the assessment link?<\u002fh3>\n        <p>While all comments are appreciated, for a faster response we recommend you contact your surgeon\'s office directly with all comments or questions requiring immediate follow-up. Also, please note that email and text message are not a secure means of transmitting sensitive information, so please use the assessment form itself instead of email or text message to provide feedback or comments about your condition. Check the <a href="#contact-info">provided contact information<\u002fa> to reach your surgeon\'s office.\n        <\u002fp>\n    <\u002fdiv>\n\n    <div id="question11">\n        <h3 id="who-reads-my-comments">Do people read my comments?<\u002fh3>\n        <p>Your surgeon and office staff will read your comments. Your comments help your surgeon and staff truly understand, from your perspective, what is really going on with you, and the details of your recovery process. Being able to explain in your own words is extremely beneficial, and helps affect the way patients like you are treated in the future.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question12">\n        <h3 id="why-3rd-party">Why do you use a 3rd-party company?<\u002fh3>\n        <p>Mainly to protect the integrity of the results collected from you. They also help organize the raw data so we can view your responses in context, and compare them to what is typical for similar patients from across the country.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question13">\n        <h3 id="contact">Have a question we didn\'t answer? Contact our outcome team!<\u002fh3>\n        <p>For questions related to your PRO assessment, please contact the patient outcome team by email at\n            <a href="mailto:dev@patientoutcomes.com">dev@patientoutcomes.com<\u002fa>,\n        or by phone at <a href="tel:+1-800-000-0001">800-000-0001<\u002fa>. For all scheduling, records, or medical questions and assistance, please contact your surgeon\'s office directly.<\u002fp>\n    <\u002fdiv>\n\n<\u002fsection>\n',
                },
            ],
            [
                apiUrl + '/questionnaire/fakesurveyId/faq',
                { status: 'Not Found', statusMessage: 'No assessment found' },
            ],
            [
                apiUrl + '/questionnaire/f55eca7cdc675201/branding',
                {
                    logoUrl:
                        'https://qa.patientoutcomes.com/static/images/org/91/email.png',
                    theme: {
                        primaryColor: 'ff0000',
                        secondaryColor: '00ff00',
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/f55eca7cdc675201/faq',
                {
                    status: 200,
                    body: {
                        success: true,
                        body: '<section>\n    <h1>Tracking Your Recovery After Surgery<\u002fh1>\n\n    <p>\n        Shortly after you are scheduled for surgery with a provider from Adirondack Health, we will ask you to fill out a quick assessment about\n        how you are functioning before surgery, and then again at various intervals\n        after surgery. These "assessments" are far more than just a survey — they are\n        rigorously-tested, scientifically-validated measurement tools. These tools are\n        called patient-reported outcomes (PROs), and they are one of the key methods\n        Adirondack Health uses to track how our patients are doing, as\n        well as how to get the best possible outcomes for you.\n    <\u002fp>\n\n    <p>\n        PROs essentially reflect the "voice of the patient" — free from the input and\n        interpretation of physicians and medical experts. We want to make sure <i>your<\u002fi>\n        voice is heard and <i>your<\u002fi> outcome is tracked. To ensure the quality of our outcome\n        information, we partner with an independent 3rd-party company to collect PROs\n        before surgery, and at various intervals for 5 years after surgery. This program\n        allows our team to respond to you, the patient, and to create a patient-centered\n        environment that supports continuous quality improvement. We greatly appreciate\n        your participation in this process.\n    <\u002fp>\n<\u002fsection>\n\n<section>\n\n    <h2>Frequently Asked Questions<\u002fh2>\n\n    <ul>\n        <li><a href="#what-are-pros">What are PRO assessments?<\u002fa><\u002fli>\n        <li><a href="#pros-are-different">How are PROs different than other measurements of my health after surgery?<\u002fa><\u002fli>\n        <li><a href="#how-long-will-it-take">How long will this take?<\u002fa><\u002fli>\n        <li><a href="#navigating-away">What happens if I navigate away from the page during my assessment?<\u002fa><\u002fli>\n        <li><a href="#complications">I\'m having problems, such as an unexpected complication after surgery. Should I still take this?<\u002fa><\u002fli>\n        <li><a href="#online-v-phone">What is the benefit of doing this online vs over the phone?<\u002fa><\u002fli>\n        <li><a href="#cant-skip-question">Why can\'t I skip questions that clearly don\'t apply to me?<\u002fa><\u002fli>\n        <li><a href="#questions-repetitive">Why do some of the questions seem repetitive?<\u002fa><\u002fli>\n        <li><a href="#took-for-another-body-part">I already filled out an assessment for my other knee/shoulder/etc. Do I need to go through these questions again?<\u002fa><\u002fli>\n        <li><a href="#does-this-matter">Why does this matter?<\u002fa><\u002fli>\n        <li><a href="#question-for-my-surgeon">I have questions for my surgeon and staff. Can I leave them as a comment in the assessment, or reply to the email/text message that contains the assessment link?<\u002fa><\u002fli>\n        <li><a href="#who-reads-my-comments">Do people read my comments?<\u002fa><\u002fli>\n        <li><a href="#why-3rd-party">Why do you use a 3rd-party company?<\u002fa><\u002fli>\n        <li><a href="#contact">Have a question we didn\'t answer? Contact our outcome team!<\u002fa><\u002fli>\n    <\u002ful>\n\n<\u002fsection>\n\n<section class="answers">\n\n    <div id="question1">\n        <h3 id="what-are-pros">What are PRO assessments?<\u002fh3>\n        <p>A patient-reported outcome (PRO) assessment is not just a typical "survey" &mdash; it is a set of statistically validated questions that have been rigorously tested through medical research. PROs are designed to measure both your physical recovery, as well as the improvement to your overall quality of life. These tools are used by orthopedic surgeons around the world, and are becoming the "gold standard" for evaluating surgical results.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question2">\n        <h3 id="pros-are-different">How are PROs different than other measurements of my health after surgery?<\u002fh3>\n        <p>Traditionally, surgical care teams focus on measuring the size of the incision or how much range of motion a patient has or how the x-ray looks to the surgeon. These factors may all have some role in surgical outcomes, but they aren\'t <i>patient driven<\u002fi>. PROs make you, the patient, an active participant in your recovery, allowing your care team to check on how <i>you<\u002fi> feel and how <i>your<\u002fi> goals are being met.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question3">\n        <h3 id="how-long-will-it-take">How long will this take?<\u002fh3>\n        <p>It usually takes about 10-20 minutes to complete a PRO assessment.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question4">\n        <h3 id="navigating-away">What happens if I navigate away from the page during my assessment?<\u002fh3>\n        <p>If you navigate away from the page while you\'re taking your assessment, you\'ll have to start again at the beginning when you return to it. So please plan on finishing in one sitting.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question5">\n        <h3 id="complications">I\'m having problems, such as an unexpected complication after surgery. Should I still take this?<\u002fh3>\n        <p>Yes, please do! While it is very rare, a small portion of the patients who have orthopedic surgery suffer from complications. We want to understand more about these complications, and why they occur, so we can learn to prevent them and better care for you, and other patients like you, in the future.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question6">\n        <h3 id="online-v-phone">What is the benefit of doing this online vs over the phone?<\u002fh3>\n        <p>First and foremost: data quality. Eliminating any outside influence while completing the assessment improves the accuracy of your answers. Another benefit is time &mdash; almost all PRO questions are multiple choice, and when doing the assessment over the phone, all answer options must be read by the assessment administrator, even when the answer options are the same for many questions. On average, it takes patients 40% less time to complete an assessment online than over the phone.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question7">\n        <h3 id="cant-skip-question">Why can\'t I skip questions that clearly don\'t apply to me?<\u002fh3>\n        <p>In order for the system to calculate a standardized score that can be compared to other patients who\'ve undergone similar treatment, each question must be answered. Some questions or answer options may not seem relevant to your situation &mdash; but the good news is, there are no "trick" questions. So please try to answer all questions to the best of your ability; and if a question asks about something you can\'t or don\'t do (like if the question asks about your ability to jump, even though it\'s not something you do very often), try to imagine yourself performing that activity, and answer the question imagining how your body would feel or react. At the end of the assessment, you will be able to include your own comments with any additional information not previously covered that you feel may be beneficial for your surgeon to know.<\u002fp>\n    <\u002fdiv>\n\n    <div>\n        <h3 id="questions-repetitive">Why do some of the questions seem repetitive?<\u002fh3>\n        <p>The questions in each PRO assessment are designed to evaluate specific areas of your current physical state. Although some questions may seem repetitive, they are evaluating different aspects of the factors that affect your recovery, such as pain, level of difficulty performing a task, etc. Please answer all questions to the best of your ability.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question8">\n        <h3 id="took-for-another-body-part">I already filled out an assessment for my other knee/shoulder/etc. Do I need to go through these questions again?<\u002fh3>\n        <p>Yes. Since procedures and practices continually change, it\'s important to monitor the progress of each individual procedure, even for the same patient.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question9">\n        <h3 id="does-this-matter">Why does this matter?<\u002fh3>\n        <p>The recovery process is different for all patients. However, there are certain standards that physicians strive for in the recovery process. PRO assessments allow physicians to compare your results to other similar individuals, and monitor trends. This allows your surgeon to better understand what to expect for your specific recovery, and can alter your plan of care if necessary.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question10">\n        <h3 id="question-for-my-surgeon">I have questions for my surgeon and staff. Can I leave them as a comment in the assessment, or reply to the email/text message that contains the assessment link?<\u002fh3>\n        <p>While all comments are appreciated, for a faster response we recommend you contact your surgeon\'s office directly with all comments or questions requiring immediate follow-up. Also, please note that email and text message are not a secure means of transmitting sensitive information, so please use the assessment form itself instead of email or text message to provide feedback or comments about your condition. Check the <a href="#contact-info">provided contact information<\u002fa> to reach your surgeon\'s office.\n        <\u002fp>\n    <\u002fdiv>\n\n    <div id="question11">\n        <h3 id="who-reads-my-comments">Do people read my comments?<\u002fh3>\n        <p>Your surgeon and office staff will read your comments. Your comments help your surgeon and staff truly understand, from your perspective, what is really going on with you, and the details of your recovery process. Being able to explain in your own words is extremely beneficial, and helps affect the way patients like you are treated in the future.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question12">\n        <h3 id="why-3rd-party">Why do you use a 3rd-party company?<\u002fh3>\n        <p>Mainly to protect the integrity of the results collected from you. They also help organize the raw data so we can view your responses in context, and compare them to what is typical for similar patients from across the country.<\u002fp>\n    <\u002fdiv>\n\n    <div id="question13">\n        <h3 id="contact">Have a question we didn\'t answer? Contact our outcome team!<\u002fh3>\n        <p>For questions related to your PRO assessment, please contact the patient outcome team by email at\n            <a href="mailto:dev@patientoutcomes.com">dev@patientoutcomes.com<\u002fa>,\n        or by phone at <a href="tel:+1-800-000-0001">800-000-0001<\u002fa>. For all scheduling, records, or medical questions and assistance, please contact your surgeon\'s office directly.<\u002fp>\n    <\u002fdiv>\n\n<\u002fsection>\n',
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/fakesurveyId/faq',
                {
                    status: 200,
                    body: {
                        status: 'Not Found',
                        statusMessage: 'No assessment found',
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/f55eca7cdc675201/branding',
                {
                    status: 200,
                    body: {
                        logoUrl:
                            'https://qa.patientoutcomes.com/static/images/org/91/email.png',
                        theme: {
                            primaryColor: 'ff0000',
                            secondaryColor: '00ff00',
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/screen',
                (function* () {
                    // yield { status: 200, body: screen4 };
                    yield { status: 200, body: screen5 };
                    yield { status: 200, body: screen6 };
                    yield { status: 200, body: screen7 };
                    yield { status: 200, body: screen8 };

                    // yield { status: 200, body: screen9 };
                    // yield { status: 200, body: screen10 };
                    // yield { status: 200, body: screen11 };
                    // yield { status: 200, body: screen12 };
                    // yield { status: 200, body: screen13 };
                    // yield { status: 200, body: screen14 };
                    // yield { status: 200, body: screen15 };
                    // yield { status: 200, body: screen16 };
                    // yield { status: 200, body: screen17 };
                    // yield { status: 200, body: screen18 };
                    // yield { status: 200, body: screen19 };
                    // yield { status: 200, body: screen20 };
                    // yield { status: 200, body: screen21 };
                    // yield { status: 200, body: screen22 };
                    // yield { status: 200, body: screen23 };
                    // yield { status: 200, body: screen24 };
                    // yield { status: 200, body: screen25 };
                    // yield { status: 200, body: screen26 };
                    // yield { status: 200, body: screen27 };

                    yield { status: 200, body: screen2 };
                    yield { status: 200, body: screen67 };
                    yield { status: 200, body: screen3 };
                    yield { status: 200, body: screenSubmit };
                    yield { status: 200, body: gratitudeScreen };
                })(),
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/4',
                { status: 200, body: question4 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/5',
                { status: 200, body: question5 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/6',
                { status: 200, body: question6 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/7',
                { status: 200, body: question7 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/8',
                { status: 200, body: question8 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/9',
                { status: 200, body: question9 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/10',
                { status: 200, body: question10 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/11',
                { status: 200, body: question11 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/12',
                { status: 200, body: question12 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/13',
                { status: 200, body: question13 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/14',
                { status: 200, body: question14 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/15',
                { status: 200, body: question15 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/16',
                { status: 200, body: question16 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/17',
                { status: 200, body: question17 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/18',
                { status: 200, body: question18 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/19',
                { status: 200, body: question19 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/20',
                { status: 200, body: question20 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/21',
                { status: 200, body: question21 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/22',
                { status: 200, body: question22 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/23',
                { status: 200, body: question23 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/24',
                { status: 200, body: question24 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/25',
                { status: 200, body: question25 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/26',
                { status: 200, body: question26 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/27',
                { status: 200, body: question27 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/2',
                { status: 200, body: question2 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/67',
                { status: 200, body: question67 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/3',
                { status: 200, body: question3 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/question/53',
                { status: 200, body: question53 },
            ],
            [
                apiUrl + '/questionnaire/75c9971ef240369c/gratitude',
                { status: 200, body: gratitude },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/branding',
                {
                    status: 200,
                    body: {
                        logoUrl:
                            'https://qa.patientoutcomes.com/static/images/org/91/email.png',
                        theme: {
                            primaryColor: '0060AA',
                            secondaryColor: '014D33',
                        },
                    },
                },
            ],
            [
                apiUrl + '/metadata',
                {
                    status: 200,
                    body: {
                        copyright: '<p>&copy; 2023 CODE Technology<\u002fp>',
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb',
                (function* () {
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'Pending',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: '',
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'Submitted',
                            statusMessage:
                                'This assessment has already been completed (thanks!)',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    };
                })(),
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/introduction',
                {
                    status: 200,
                    body: {
                        questionnaireId: 'cf2787be2e387dfb',
                        text: 'Thank you for taking time to answer these questions about your health!<br><div class="small">For the following questions, please choose the answer that best matches your experience, then click ‘<b>Next</b>’.<div>',
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/screen',
                (function* () {
                    yield {
                        status: 200,
                        body: { type: 'Introduction', status: 0 },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 54,
                            dataId: 54,
                            type: 'Question',
                            previousScreenId: null,
                            status: 10,
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 55,
                            dataId: 55,
                            type: 'Question',
                            previousScreenId: 54,
                            status: 20,
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 56,
                            dataId: 56,
                            type: 'Question',
                            previousScreenId: 55,
                            status: 40,
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 57,
                            dataId: 57,
                            type: 'Question',
                            previousScreenId: 56,
                            status: 60,
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 58,
                            dataId: 58,
                            type: 'Splash',
                            previousScreenId: 57,
                            status: 80,
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 59,
                            dataId: 59,
                            type: 'Submit',
                            previousScreenId: 58,
                            status: 100,
                        },
                    };
                    yield {
                        status: 200,
                        body: {
                            id: 60,
                            dataId: 60,
                            type: 'Gratitude',
                            previousScreenId: 58,
                            status: 100,
                        },
                    };
                })(),
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/screen/54',
                {
                    status: 200,
                    body: {
                        id: 54,
                        dataId: 54,
                        type: 'Question',
                        previousScreenId: null,
                        status: 2,
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/screen/55',
                {
                    status: 200,
                    body: {
                        id: 55,
                        dataId: 55,
                        type: 'Question',
                        previousScreenId: 54,
                        status: 4,
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/screen/56',
                {
                    status: 200,
                    body: {
                        id: 56,
                        dataId: 56,
                        type: 'Question',
                        previousScreenId: 55,
                        status: 6,
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/screen/57',
                {
                    status: 200,
                    body: {
                        id: 57,
                        dataId: 57,
                        type: 'Question',
                        previousScreenId: 56,
                        status: 10,
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/screen/58',
                {
                    status: 200,
                    body: {
                        id: 58,
                        dataId: 58,
                        type: 'Splash',
                        previousScreenId: 57,
                        status: 80,
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/submit',
                {
                    status: 200,
                    body: {
                        id: 123,
                        questionnaireId: 'cf2787be2e387dfb',
                        batteryId: null,
                        text: 'Please share any comments that will help us better care for patients like you.',
                        answerSettings: {
                            validation: {
                                multipleAnswersAvailable: false,
                                mandatoryAnswer: false,
                                commentAvailable: true,
                                commentMandatory: false,
                            },
                            values: {
                                type: 'list',
                                list: [],
                            },
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/submit/answer',
                {
                    status: 200,
                    body: {
                        comment: 'test',
                        questionId: 123,
                        values: [],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/splash/58',
                {
                    status: 200,
                    body: {
                        id: 58,
                        questionnaireId: '53f1c23e5f95d42e',
                        batteryId: 12,
                        text: '<b>Stiffness<\u002fb>: The following questions concern the amount of joint stiffness you have experienced during the <b>last week<\u002fb> in your hip. Stiffness is a sensation of restriction or slowness in the ease with which you move your hip joint. <br><br> If you do not currently perform some of the activities described in these questions, please try to imagine how your hip might feel when performing these activities,  and answer accordingly.',
                        answerSettings: {
                            validation: {
                                multipleAnswersAvailable: false,
                                mandatoryAnswer: false,
                                commentAvailable: false,
                                commentMandatory: false,
                            },
                            values: {
                                type: 'list',
                                list: [],
                            },
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/splash/58/answer',
                {
                    status: 200,
                    body: {
                        comment: 'test',
                        questionId: 58,
                        values: [],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/54',
                {
                    status: 200,
                    body: {
                        id: 54,
                        questionnaireId: 'cf2787be2e387dfb',
                        batteryId: null,
                        text: 'Since you last completed this questionnaire, have you had additional surgery on the <b>same hip<\u002fb>? If yes, please select the reason.',
                        answerSettings: {
                            validation: {
                                multipleAnswersAvailable: true,
                                mandatoryAnswer: true,
                                commentAvailable: false,
                                commentMandatory: false,
                            },
                            values: {
                                type: 'list',
                                list: [
                                    {
                                        id: 231,
                                        displayText: 'Yes: Infection',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 232,
                                        displayText: 'Yes: Dislocation',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 233,
                                        displayText:
                                            'Yes: Fracture around the implant',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 234,
                                        displayText:
                                            'Yes: Loosening of the implant',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 235,
                                        displayText:
                                            'Yes: Other reason (please describe below)',
                                        validation: {
                                            commentAvailable: true,
                                            commentMandatory: true,
                                        },
                                    },
                                    {
                                        id: 236,
                                        displayText: 'No',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                ],
                            },
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/splash/54/answer',
                {
                    status: 200,
                    body: {
                        questionId: 54,
                        values: [
                            { id: 234 },
                            { id: 235, comment: 'test data' },
                        ],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/55',
                {
                    status: 200,
                    body: {
                        id: 55,
                        questionnaireId: 'cf2787be2e387dfb',
                        batteryId: null,
                        text: '55 Since you last completed this questionnaire, have you had additional surgery on the <b>same hip<\u002fb>? If yes, please select the reason.',
                        answerSettings: {
                            validation: {
                                multipleAnswersAvailable: true,
                                mandatoryAnswer: true,
                                commentAvailable: false,
                                commentMandatory: false,
                            },
                            values: {
                                type: 'list',
                                list: [
                                    {
                                        id: 231,
                                        displayText: '55 Yes: Infection',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 233,
                                        displayText:
                                            '55 Yes: Fracture around the implant',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 235,
                                        displayText:
                                            '55 Yes: Other reason (please describe below)',
                                        validation: {
                                            commentAvailable: true,
                                            commentMandatory: true,
                                        },
                                    },
                                    {
                                        id: 236,
                                        displayText: '55 No',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                ],
                            },
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/55/answer',
                {
                    status: 200,
                    body: {
                        comment: 'test',
                        questionId: 55,
                        values: [{ id: 234 }, { id: 235 }],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/56',
                {
                    status: 200,
                    body: {
                        id: 56,
                        questionnaireId: 'cf2787be2e387dfb',
                        batteryId: null,
                        text: '56 Since you last completed this questionnaire, have you had additional surgery on the <b>same hip<\u002fb>? If yes, please select the reason.',
                        answerSettings: {
                            validation: {
                                multipleAnswersAvailable: false,
                                mandatoryAnswer: false,
                                commentAvailable: true,
                                commentMandatory: true,
                            },
                            values: {
                                type: 'list',
                                list: [
                                    {
                                        id: 232,
                                        displayText: '56 Yes: Dislocation',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 233,
                                        displayText:
                                            '56 Yes: Fracture around the implant',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },

                                    {
                                        id: 235,
                                        displayText:
                                            '56 Yes: Other reason (please describe below)',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 236,
                                        displayText: '56 No',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                ],
                            },
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/splash/56/answer',
                {
                    status: 200,
                    body: {
                        comment: 'test answer',
                        questionId: 55,
                        values: [{ id: 235 }],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/57',
                {
                    status: 200,
                    body: {
                        id: 57,
                        questionnaireId: 'cf2787be2e387dfb',
                        batteryId: null,
                        text: '57 Since you last completed this questionnaire, have you had additional surgery on the <b>same hip<\u002fb>? If yes, please select the reason.',
                        answerSettings: {
                            validation: {
                                multipleAnswersAvailable: true,
                                mandatoryAnswer: false,
                                commentAvailable: true,
                                commentMandatory: false,
                            },
                            values: {
                                type: 'list',
                                list: [
                                    {
                                        id: 231,
                                        displayText: '57 Yes: Infection',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 232,
                                        displayText: '57 Yes: Dislocation',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 233,
                                        displayText:
                                            '57 Yes: Fracture around the implant',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 234,
                                        displayText:
                                            '57 Yes: Loosening of the implant',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                    {
                                        id: 236,
                                        displayText: '57 No',
                                        validation: {
                                            commentAvailable: false,
                                            commentMandatory: false,
                                        },
                                    },
                                ],
                            },
                        },
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/54/answer',
                {
                    status: 200,
                    body: {
                        comment: 'test',
                        questionId: 54,
                        values: [{ id: 231 }, { id: 232 }, { id: 235 }],
                    },
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/56/answer',
                {
                    status: 200,
                    body: {
                        comment: 'mocked comment',
                        questionId: 56,
                        values: [{ id: 231 }, { id: 232 }, { id: 235 }],
                    },
                },
            ],
        ]),
    ],
    [
        'POST',
        new Map<string, object>([
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/54/answer',
                {
                    status: 200,
                    body: {},
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/55/answer',
                {
                    status: 200,
                    body: {},
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/56/answer',
                {
                    status: 200,
                    body: {},
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/57/answer',
                {
                    status: 200,
                    body: {},
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/question/58/answer',
                {
                    status: 200,
                    body: {},
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/splash/58/answer',
                {
                    status: 200,
                    body: {},
                },
            ],
        ]),
    ],
    [
        'PUT',
        new Map<string, object>([
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb/branding',
                {
                    status: 200,
                    body: {},
                },
            ],
            [
                apiUrl + '/questionnaire/cf2787be2e387dfb',
                {
                    status: 200,
                    body: {
                        status: 200,
                        body: {
                            id: 3289574,
                            status: 'In Progress',
                            statusMessage: '',
                            batteries: [
                                {
                                    id: 12,
                                    title: 'HOOS Hip Scale',
                                    copyright: null,
                                },
                                {
                                    id: 8,
                                    title: 'PROMIS Global 10',
                                    copyright: null,
                                },
                            ],
                        },
                    },
                },
            ],
        ]),
    ],
]);

@Injectable({ providedIn: 'root' })
export class MockService {
    public getMockData<T>(path: string, method: string, body?: unknown): T {
        let _data;
        try {
            const responseData = (data.get(method) as Map<string, any>).get(
                path
            );

            if (responseData instanceof Function) {
                _data = responseData.call(null);
            } else if (responseData[Symbol.iterator]) {
                _data = responseData.next().value;
            } else {
                _data = responseData;
            }

            return _data;
        } catch (e) {
            _data = this.getDefault({
                status: 404,
                statusText: 'There is no mock for that request.',
            });
        }
        return _data;
    }
    private getDefault(data: any) {
        return data;
    }
}
